import React, { FC, ReactElement } from 'react'
import { Location, Navigate, useLocation } from 'react-router'
import { Branding } from '../../React/Common/API/BrandingAPI'
import { useBranding } from '../../React/Common/Hooks/useBranding'
import { IsVarEmpty } from '../../NonReact/utils/GlobalFunctions'
import Loader from '../../React/Common/Components/Loader'
import { AUTH_ROUTE_PATH } from '../Constants/Constants'
import { redirectToServlet, ServletCmds } from '../../NonReact/constants/ServletCommands'
import { SLASH } from '../../NonReact/constants/Separators'
import { EMPTY_STRING } from '../../NonReact/constants/Common'

type PropsCheckTrue = {
    children: ReactElement | ReactElement[]
    checkIsTrue?: Nullable<boolean>
    checkIsFalse?: undefined
    redirectPathFunc?: (branding: Nullable<Branding>) => string
    redirectPath?: Nullable<string>
}

type PropsCheckFalse = {
    children: ReactElement | ReactElement[]
    checkIsTrue?: undefined
    checkIsFalse?: Nullable<boolean>
    redirectPathFunc?: (branding: Nullable<Branding>) => string
    redirectPath?: string
}

type Props = PropsCheckTrue | PropsCheckFalse

export const GenericGuard: FC<Props> = ({ children, checkIsTrue, checkIsFalse, redirectPath }: Props): ReactElement => {
    const location: Location = useLocation()

    const branding: Nullable<Branding> = useBranding()

    if ((IsVarEmpty(checkIsTrue) && IsVarEmpty(checkIsFalse)) || !branding) {
        return (
            <div className='router-loader-container'>
                <Loader />
            </div>
        )
    }

    if (checkIsTrue === false || checkIsFalse === true) {
        if (redirectPath?.toLowerCase()?.includes('cmd_')) {
            redirectToServlet(redirectPath?.replace(SLASH, EMPTY_STRING) as ServletCmds)

            return <></>
        }

        return <Navigate to={redirectPath ?? AUTH_ROUTE_PATH} replace state={{ from: location }} />
    }

    return <>{children}</>
}
